<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div class="flex flex-col">
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Motivos cuando un pedido o entrega no se acepta.
                Ej.: cliente ausente, precio incorrecto, exceso
                de tiempo. Úsalo para dar seguimiento y corregir
                causas.
              </p>
            </div>
          </mat-menu>

          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            De Rechazo
          </h2>
        </div>

        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los motivos de <b>rechazo</b> en un <b>socio de negocio</b> para
          los procesos
          de <b>cambios</b> y <b>devoluciones de productos</b>.
        </div>
      </div>
      <div class="flex items-center space-x-2">
        <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1, 0]"
          (selectionFilterApply)="applyStatusFilter()">
        </app-status-filters>
        <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
        </button>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort [trackBy]="trackByFn">
              <!-- Nombre -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                <td mat-cell *matCellDef="let payment" class="text-sm uppercase leading-tight">
                  <div *ngIf="getCode(payment) as code">
                    <b class="f-10">{{ code }}</b>
                  </div>
                  {{ payment.name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="withoutPrice">
                <th mat-header-cell *matHeaderCellDef>Sin Precio</th>
                <td mat-cell *matCellDef="let payment">
                  <mat-slide-toggle [(ngModel)]="payment.withoutPrice" [checked]="payment.withoutPrice === true"
                    (change)="onWithoutPriceChange($event.checked, payment)" color="primary">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <ng-container matColumnDef="freeStock">
                <th mat-header-cell *matHeaderCellDef>
                  Libera Stock
                </th>
                <td mat-cell *matCellDef="let payment">
                  <mat-slide-toggle [checked]="payment.freeStock === true"
                    (change)="onFreeStockChange($event.checked, payment)" color="primary">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <ng-container matColumnDef="acceptComment">
                <th mat-header-cell *matHeaderCellDef>
                  Acepta Comentario
                </th>
                <td mat-cell *matCellDef="let payment">
                  <mat-slide-toggle [checked]="payment.acceptComment === true"
                    (change)="onAcceptChange($event.checked, payment)" color="primary">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <ng-container matColumnDef="isWaste">
                <th mat-header-cell *matHeaderCellDef>
                  Es merma
                </th>
                <td mat-cell *matCellDef="let payment">
                  <mat-slide-toggle [checked]="payment.isWaste === true"
                    (change)="onWasteChange($event.checked, payment)" color="primary">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let payment">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="payment.statusId == 1"
                    [(ngModel)]="payment.statusId" [color]="'success'"
                    (ngModelChange)="onStatusChange($event, payment)">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let payment" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(payment)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(payment)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10 bg-white dark:bg-gray-900"></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b h-16"></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageIndex]="pageIndex" [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>
    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #createForm="ngForm">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentCreateReasonRejection.name" name="name" required>
          </mat-form-field>
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="currentCreateReasonRejection.typeIds" name="typeIds" multiple required>
              <mat-option *ngFor="let type of filteredReasonRejectionTypeList" [value]="type._id">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createReasonRejection()"
          [disabled]="!createForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #editForm="ngForm">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input matInput [(ngModel)]="currentUpdateReasonRejection.name" name="name" required>
          </mat-form-field>
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="currentUpdateReasonRejection.typeIds" name="typeIds" multiple required>
              <mat-option *ngFor="let type of filteredReasonRejectionTypeList" [value]="type._id">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="updateReasonRejection(currentUpdateReasonRejection._id)"
          [disabled]="!editForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
  <!-- Filtros -->
  <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="clearFilters()">
    <app-general-filters [form]="form" [rejectionTypeList]="reasonRejectionTypeList" [rejectionTypeById]="true"></app-general-filters>
  </app-filter>
</mat-sidenav-container>